export default [
  'jpeg', 'png', 'gif', 'bmp', 'jpg',
];
